export const ENDPOINT = {
  INDEX: '/',
  LOGIN: '/login',
  CREATE_LEAD: '/create-lead',
  LIST_LEADS: '/list-leads',
  EDIT_LEAD: '/edit-lead',
  LEAD_DETAIL: '/lead-detail',
  INTRODUCER: '/introducer',
  LIST_INTRODUCER: '/list-introducers',
  HOME: '/home',
  PAGE_NOT_FOUND: '/page-not-found',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  ADMIN_SETTINGS: '/admin-settings',
  POSSIBLE_DUPLICATES: '/possible-duplicates',
  SELECT_REFERRAL_TYPE: '/select-referral-type',
  EMBEDDED_JOURNEY: {
    LAYOUT: '/embed',
    INFORMATION: 'information',
    YOUR_DETAILS: 'your-details',
    INDICATIVE_QUOTE: 'indicative-quote'
  },
  UNMATCHED: '*'
};

export const ROUTE_NAME = {
  INDEX: 'index',
  LOGIN: 'login',
  CREATE_LEAD: 'create-lead',
  LIST_LEADS: 'list-leads',
  EDIT_LEAD: 'edit-lead',
  LEAD_DETAIL: 'lead-detail',
  INTRODUCER: 'introducer-code',
  LIST_INTRODUCER: 'list-introducer',
  PAGE_NOT_FOUND: 'page-not-found',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  ADMIN_SETTINGS: 'admin-settings',
  POSSIBLE_DUPLICATES: 'possible-duplicates',
  SELECT_REFERRAL_TYPE: 'select-referral-type',
  EMBEDDED_JOURNEY: {
    INFORMATION: 'embed-information',
    YOUR_DETAILS: 'embed-your-details',
    INDICATIVE_QUOTE: 'embed-indicative-quote'
  },
  DASHBOARD: 'dashboard'
};
